import { gsap, Power3 } from "gsap";

export default class PropertyViewCount {
    constructor() {
        this.counter = document.querySelector('.js-view-count');
        this.closeBtn = document.querySelector('.js-view-count-close');

        if (!this.getCookie('view_count_closed')) {
            this.reveal();
        }

        this.bindEvents();
    }

    bindEvents() {
        this.closeBtn.addEventListener("click", (e) => {
            this.close();
        });
    }

    reveal() {
        if (window.matchMedia('(min-width: 1024px)').matches) {
            gsap.to(this.counter, {
                duration: .25,
                delay: .25,
                y: '0%',
                opacity: 1,
                ease: Power3.in,
                onComplete: () => {
                    this.counter.classList.add('active');
                }
            });
        } else {
            this.counter.classList.add('active');
        }
    }


    close() {
        document.cookie = "view_count_closed=true";

        if (window.matchMedia('(min-width: 1024px)').matches) {
            gsap.to(this.counter, {
                duration: .25,
                y: '100%',
                opacity: 0,
                ease: Power3.in,
                onComplete: () => {
                    this.counter.style.display = 'none';
                }
            });
        } else {
            gsap.to(this.counter, {
                duration: .25,
                opacity: 0,
                ease: Power3.in,
                onComplete: () => {
                    this.counter.style.display = 'none';
                }
            });
        }

    }

    getCookie(name) {
        let match = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
        return match ? match[1] : false;
    }

}

new PropertyViewCount;